import { render, staticRenderFns } from "./newFpaDetail.vue?vue&type=template&id=7045bac6&scoped=true"
import script from "./newFpaDetail.vue?vue&type=script&lang=js"
export * from "./newFpaDetail.vue?vue&type=script&lang=js"
import style0 from "./newFpaDetail.vue?vue&type=style&index=0&id=7045bac6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7045bac6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7045bac6')) {
      api.createRecord('7045bac6', component.options)
    } else {
      api.reload('7045bac6', component.options)
    }
    module.hot.accept("./newFpaDetail.vue?vue&type=template&id=7045bac6&scoped=true", function () {
      api.rerender('7045bac6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/fpaManage/fpaPermanent/newFpaDetail.vue"
export default component.exports